module.exports = __webpack_public_path__ + "img/143-Jet Black SFTN Mat.jpg";